export default __webpack_public_path__ + "static/profile-59615a2c26ba7ca07476733bf40fdec1.jpeg";